import axios from "axios"

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
})

interface Object {
  [key: string]: string;
}

export const createUrlParams = (obj: object): string => {
  // FIXME
  let params = obj as Object
  for (let key in obj as Object) {
    if (params[key] === "") {
      delete params[key]
    }
  }

  return `?${new URLSearchParams(params).toString()}`
}

export default api
